import axios, {AxiosInstance, AxiosRequestConfig} from "axios";

const config: AxiosRequestConfig = {
    baseURL: process.env.REACT_APP_BASE_URL,
    headers: {
        Accept: "application/json",
        'content-type': 'multipart/form-data',
        "ngrok-skip-browser-warning": 123
    }
}

const apiMultipart: AxiosInstance = axios.create(config)

export default apiMultipart
